import React from 'react';
import FormField from './FormField';
import './DynamicForm.css';

function DynamicForm({
    fields,
    formData,
    onChange,
    onSubmit,
    readOnlyFields = [],
    submitLabel = '提交'
}) {
    const handleFieldChange = (fieldName, value) => {
        onChange({
            ...formData,
            [fieldName]: value
        });
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        onSubmit(formData);
    };

    const sortedFields = [...(fields || [])]
        .filter((field) => field.isMigrated !== false)
        .sort((fieldA, fieldB) => (fieldA.displayOrder || 0) - (fieldB.displayOrder || 0));

    if (sortedFields.length === 0) {
        return <div className="dynamic-form__loading">暂无可编辑字段。</div>;
    }

    return (
        <form onSubmit={handleSubmit} className="dynamic-form">
            <div className="dynamic-form__grid">
                {sortedFields.map((field) => (
                    <FormField
                        key={field.name}
                        field={field}
                        value={formData[field.name]}
                        onChange={handleFieldChange}
                        readOnly={readOnlyFields.includes(field.name)}
                    />
                ))}
            </div>

            <button type="submit" className="app-button app-button--primary dynamic-form__submit">
                {submitLabel}
            </button>
        </form>
    );
}

export default DynamicForm;
